export const cms = {
    state: {
        user: {},
        client: {},
        project: {},
        breadcrumbs: null,
        echo_error: false,
        loginmodal: {
            show: false,
            credentials: {
                email: null,
                password: null,
                remember: false,
            },
            callback: () => {},
        },
    },
    mutations: {
        setUser(state, data) {
            state.user = data;
        },
        setClient(state, data) {
            state.client = data;
        },
        setProject(state, data) {
            state.project = data;
        },
        setBreadcrumbs(state, data) {
            state.breadcrumbs = data;
        },
        setEchoError(state, data) {
            state.echo_error = data;
        },

        /**
         * LoginModal
         */
        setLoginModalShow(state, show) {
            state.loginmodal.show = show;
        },
        setLoginModalCredentials(state, credentials) {
            state.loginmodal.credentials = credentials;
        },
        setLoginModalEmail(state, email) {
            state.loginmodal.credentials.email = email;
        },
        setLoginModalPassword(state, password) {
            state.loginmodal.credentials.password = password;
        },
        setLoginModalRemember(state, remember) {
            state.loginmodal.credentials.remember = remember;
        },
        setLoginModalCallback(state, callback) {
            state.loginmodal.callback = callback;
        },
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getClient(state) {
            return state.client;
        },
        getClientShortname(state) {
            return state.client.short_name;
        },
        getClientBaseUrl(state) {
            return state.client.base_url;
        },
        getProject(state) {
            return state.project;
        },
        getProjectSlug(state) {
            return state.project.slug;
        },
        getProjectUUID(state) {
            return state.project.uuid;
        },
        hasRole: (state) => (role) => {
            // TODO: get from user object
            return true;
        },
        getBreadcrumbs(state) {
            return state.breadcrumbs;
        },
        getEchoError(state) {
            return state.echo_error;
        },

        /**
         * LoginModal
         */
        getLoginModalShow(state) {
            return state.loginmodal.show;
        },
        getLoginModalCredentials(state) {
            return state.loginmodal.credentials;
        },
        getLoginModalEmail(state) {
            return state.loginmodal.credentials.email;
        },
        getLoginModalPassword(state) {
            return state.loginmodal.credentials.password;
        },
        getLoginModalRemember(state) {
            return state.loginmodal.credentials.remember;
        },
        getLoginModalCallback(state) {
            return state.loginmodal.callback;
        },
    },
    actions: {
        showLoginModal({ commit, state }, callback) {
            commit('setLoginModalShow', true);
            commit('setLoginModalCallback', callback);
        },
        closeLoginModal({ commit, state }) {
            commit('setLoginModalShow', false);
            commit('setLoginModalCredentials', { username: null, password: null, remember: false });
            commit('setLoginModalCallback', () => {});
        },
        updateProject({ commit, state }, data) {
            const project = Object.assign({}, state.project, data);
            commit('setProject', project);
        },
    },
};
